import { useState } from "react";
import { Container } from "@mui/material";
import { ContactHeader } from "./ContactHeader";
import { ContactAlert } from "./ContactAlert";
import { ContactForm } from "./ContactForm";
import emailjs from "@emailjs/browser";

export const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    type: "",
  });

  const [generalMessage, setGeneralMessage] = useState("");

  const [entries, setEntries] = useState([{ id: 1 }]);

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleGeneralMessageChange = (e) => {
    setGeneralMessage(e.target.value);
  };

  const handleEntryChange = (e, index) => {
    const { name, value } = e.target;
    const updatedEntries = [...entries];
    updatedEntries[index] = { ...updatedEntries[index], [name]: value };
    setEntries(updatedEntries);
  };

  const handleImageUpload = (images, index) => {
    const updatedEntries = [...entries];
    updatedEntries[index] = {
      ...updatedEntries[index],
      images: [...(updatedEntries[index].images || []), ...images],
    };
    setEntries(updatedEntries);
  };

  const addNewEntry = () => {
    setEntries([...entries, { id: Date.now() }]);
  };

  const removeEntry = (id) => {
    if (entries.length > 1) {
      setEntries(entries.filter((entry) => entry.id !== id));
    }
  };

  const removeImage = (imgIndex, entryIndex) => {
    const updatedEntries = [...entries];
    updatedEntries[entryIndex].images.splice(imgIndex, 1);
    setEntries(updatedEntries);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const now = new Date();
    const formattedTimestamp = now.toLocaleString("en-US", {
      weekday: "short",
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

    try {
      const entriesString = JSON.stringify(entries, null, 2);

      const templateParams = {
        to_email: "world.halal123@gmail.com",
        from_name: formData.name,
        from_email: formData.email,

        subject: `${
          formData.type === "correction"
            ? "Correction Request"
            : formData.type === "addition"
            ? "New Listing"
            : "General Inquiry"
        }`,
        customer_name: formData.name || "Not provided",
        customer_email: formData.email || "Not provided",
        timestamp: formattedTimestamp,
        form_type: formData.type || "Unknown",
        message_content:
          formData.message || generalMessage || "No message provided",
        entries_data: entriesString,
        current_year: now.getFullYear().toString(),
        organization: "Halal World",

        has_entries: entries.length > 0 ? "yes" : "no",
        first_entry_type: entries[0]?.errorType || "None",
        first_entry_location: entries[0]?.location || "None",
      };

      await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        templateParams,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      );      

      setLoading(false);
      setSubmitted(true);
      setFormData({ name: "", email: "", type: "", message: "" });
      setGeneralMessage("");
      setEntries([{ id: 1 }]);
    } catch (err) {
      console.error("Email sending failed:", err);
      setLoading(false);
      setError("Failed to send. Please try again.");
    }
  };

  return (
    <Container maxWidth="md" sx={{ mt: 8, mb: 6 }}>
      <ContactHeader />
      <ContactAlert error={error} submitted={submitted} />
      <ContactForm
        onSubmit={handleSubmit}
        formData={formData}
        handleChange={handleChange}
        loading={loading}
        setFormData={setFormData}
        entries={entries}
        handleEntryChange={handleEntryChange}
        handleImageUpload={handleImageUpload}
        removeImage={removeImage}
        addNewEntry={addNewEntry}
        removeEntry={removeEntry}
        generalMessage={generalMessage}
        handleGeneralMessageChange={handleGeneralMessageChange}
      />
    </Container>
  );
};
